<template>
  <div class="NewAuthority">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
/* .NewAuthority{
  overflow: hidden;
} */
</style>